// extracted by mini-css-extract-plugin
export default {"submit":"ForgotPasswordScreen_submit__9qz1p","button":"ForgotPasswordScreen_button__mxX8r","input":"ForgotPasswordScreen_input__WyneF","login":"ForgotPasswordScreen_login__QB2SB"};